interface AdminStatCardProps {
  label: string;
  value: string;
  icon: string;
  change?: number;
  hint?: string;
  tone?: "primary" | "accent" | "secondary" | "neutral";
}

const toneClasses: Record<NonNullable<AdminStatCardProps["tone"]>, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
  neutral: "bg-background-200 text-foreground-700",
};

export default function AdminStatCard({ label, value, icon, change, hint, tone = "neutral" }: AdminStatCardProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-start justify-between gap-3">
        <span className="text-xs font-semibold uppercase tracking-wide text-foreground-500">{label}</span>
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${toneClasses[tone]}`}>
          <i className={`${icon} text-lg`}></i>
        </span>
      </div>
      <div className="mt-3 font-heading text-2xl font-extrabold text-foreground-950">{value}</div>
      <div className="mt-1.5 flex items-center gap-2">
        {typeof change === "number" && (
          <span
            className={`inline-flex items-center gap-1 text-xs font-semibold ${
              change >= 0 ? "text-accent-700" : "text-secondary-700"
            }`}
          >
            <i className={change >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
            {Math.abs(change)}%
          </span>
        )}
        {hint && <span className="text-xs text-foreground-500">{hint}</span>}
      </div>
    </div>
  );
}